// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__fiZOW"};